import { Session } from '@models/Sessions/Session';
import { IRoles } from '@services/config.service';

export function matchRole(
  session: Session,
  roles: IRoles,
  roleName: string,
  comparator?: string,
) {
  let compareFunc = function (actual, required) {
    return actual === required;
  };
  if (comparator == '<=')
    compareFunc = function (actual, required) {
      return actual <= required;
    };
  if (comparator == '>=')
    compareFunc = function (actual, required) {
      return actual >= required;
    };

  return compareFunc(session.me.role, roles[roleName]);
}

export function matchCreatedBy(
  session: Session,
  createdBy: string,
  isEnabled: boolean,
) {
  if (isEnabled) {
    return session.created_by === createdBy;
  }

  return true;
}

export function matchIsFollowed(session: Session, isEnabled: boolean) {
  if (isEnabled) {
    return session.i_follow;
  }

  return true;
}

export function sortByDate(s1: Session, s2: Session, descending: boolean) {
  if (descending) {
    return (new Date(s2.created_at) as any) - (new Date(s1.created_at) as any);
  }

  return (new Date(s1.created_at) as any) - (new Date(s2.created_at) as any);
}

export function paginationStartFrom<T>(
  input: T[],
  page: number,
  length: number,
) {
  page = +page;
  return input.slice((page - 1) * length, page * length);
}
